module.exports = __webpack_public_path__ + "media/images/weather/43_day_g-4ea35d1d536dbca231ce9d56af520268.png";